module.exports = __webpack_public_path__ + "web.config";


//////////////////
// WEBPACK FOOTER
// ./web.config
// module id = 1216
// module chunks = 0